module.exports = __webpack_public_path__ + "img/cases-brand-hla-12.b6a64fb4.png";